
import {
  // brand-invariant groups — shared verbatim with b2c (see FOUNDATIONS-GAP.md §2)
  additional,
  background,
  category,
  core,
  deepGrey,
  deepPurple,
  disabled,
  error,
  ghost,
  green,
  orange,
  purple,
  red,
  secondary,
  success,
  transparent,
  turquoise,
  warning,
} from './param-palette'
import type {
  Accent,
  Icons,
  Overlay,
  Primary,
  Tertiary,
  Text,
  Theme,
} from './themes'

export const primary = {
  maxContrast: '#171717',
  highContrast: '#262626',
  upperMidContrast: '#bcbcbc',
  midContrast: '#dcdcdc',
  lowerMidContrast: '#eaeaea',
  lowContrast: '#f0eeee',
  reversedContrast: '#ffffff',
  // legacy aliases
  mainContrast: '#262626',
  mediumContrast: '#eaeaea',
} as const satisfies Primary

export const tertiary = {
  maxContrast: '#171717',
  highContrast: '#262626',
  upperMidContrast: '#bcbcbc',
  midContrast: '#dcdcdc',
  lowerMidContrast: '#eaeaea',
  lowContrast: '#f0eeee',
  reversedContrast: '#ffffff',
  // legacy aliases
  main: '#262626',
  upperMediumContrast: '#bcbcbc',
  mediumContrastAlternative: '#dcdcdc',
  mediumContrast: '#eaeaea',
} as const satisfies Tertiary

export const accent = {
  maxContrast: '#053d3c',
  highContrast: '#0b7573',
  lowerMidContrast: '#c6efee',
  lowContrast: '#e3f7f7',
  surfaceElement: '#ebecee',
} as const satisfies Accent

export const text = {
  title: '#171717',
  body: '#262626',
  description: '#737373',
  caption: '#737373',
  titleReversed: '#ffffff',
  disabled: '#bcbcbc',
  emptyState: '#bcbcbc',
} as const satisfies Text

export const icons = {
  main: '#262626',
  logo: '#450d87',
} as const satisfies Icons

export const overlay = {
  main: '#eaeaea',
  accent: '#262626b8',
  tooltip: '#262626b8',
} as const satisfies Overlay

export const palette = {
  additional,
  background,
  disabled,
  error,
  ghost,
  icons,
  overlay,
  primary,
  tertiary,
  secondary,
  accent,
  success,
  text,
  transparent,
  warning,
  deepPurple,
  turquoise,
  green,
  orange,
  red,
  purple,
  core,
  category,
  deepGrey,
} as const satisfies Theme
